import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }
const _hoisted_2 = { class: "content-grid__header" }
const _hoisted_3 = { class: "content-grid__filters" }

import Card from '@/components/layout/Card.vue';
import BackLinkTitle from '@/components/layout/BackLinkTitle.vue';
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue';
import SearchInput from "@/components/layout/SearchInput.vue";
import {useI18n} from "vue3-i18n";
import {computed, onMounted, ref} from "vue";
import {DocumentCategoryHelper} from "@/types";
import DocumentsTable from '@/components/tables/DocumentsTable.vue';
import {Document} from "@/types/entities/document";
import {useDocumentService} from "@/inversify.config";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentCategory',
  props: {
    documentCategorySlug: {}
  },
  setup(__props: any) {

const props = __props

const {t} = useI18n();

const documentService = useDocumentService();

const searchValue = ref("");
const documentsAreLoading = ref(false)
const documentsMatchingCategory = ref<Document[]>([]);

const documentCategory = computed(() => DocumentCategoryHelper.getCategoryNameFromSlug(props.documentCategorySlug))
const documentCategoryKey = computed(() => DocumentCategoryHelper.getCategoryValueOfKey(documentCategory.value))

onMounted(async () => {
  await loadAllDocuments()
})

async function loadAllDocuments() {
  documentsAreLoading.value = true;
  documentsMatchingCategory.value = [];

  let documents = await documentService.getAllDocuments();
  if (documents && documents.length > 0) {
    documentsMatchingCategory.value = documents.filter((x: Document) => x.category == documentCategoryKey.value)
  }
  documentsAreLoading.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)(`document.categories.${documentCategory.value}.name`)
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BackLinkTitle, {
        title: _unref(t)(`document.categories.${documentCategory.value}.name`)
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SearchInput, {
          modelValue: searchValue.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        _createVNode(DocumentsTable, {
          documents: documentsMatchingCategory.value,
          "is-loading": documentsAreLoading.value,
          "search-value": searchValue.value,
          onDocumentsUpdated: loadAllDocuments
        }, null, 8, ["documents", "is-loading", "search-value"])
      ]),
      _: 1
    })
  ]))
}
}

})